import EpisodeTitle, { EpisodeTitleProps } from './EpisodeTitle';

export default EpisodeTitle;
export type { EpisodeTitleProps };
